import styled, { css } from "styled-components";
import { theme } from '../../theme'

function variantButtonStyles({ variant }) {
   switch (variant) {
      case "secondary":
         return css`
            color: ${({ theme }) => theme.colors?.white};
            background-color: ${({ theme }) => theme.colors?.japaaBlack};
            // border: 1px solid ${({ theme }) => theme.colors?.borderColor};

            &:hover,
            &:active {
               opacity: 0.7;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               opacity: 40%;
               cursor: not-allowed;
            }
         `;
      case "outline-primary":
         return css`
            color: ${({ theme }) => theme.colors?.green};
            background-color: ${({ theme }) => theme.colors?.white};
            border: 1px solid ${({ theme }) => theme.colors?.green};

            &:hover,
            &:active {
               opacity: 0.7;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               opacity: 40%;
               cursor: not-allowed;
            }
         `;
      case "outline-secondary":
         return css`
            color: ${({ theme }) => theme.colors?.grey};
            background-color: ${({ theme }) => theme.colors?.white};
            border: 1px solid ${({ theme }) => theme.colors?.grey};

            &:hover,
            &:active {
               opacity: 0.7;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               opacity: 40%;
               cursor: not-allowed;
            }
         `;
      case "outline-red":
         return css`
            color: ${({ theme }) => theme.colors?.buttonRed};
            background-color: ${({ theme }) => theme.colors?.white};
            border: 1px solid ${({ theme }) => theme.colors?.buttonRed};

            &:hover,
            &:active {
               opacity: 0.7;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               opacity: 40%;
               cursor: not-allowed;
            }
         `;
      case "invert":
         return css`
            color: #444444;
            background-color: #fff;
            border: 1px solid ${theme.colors.white};

            &:hover,
            &:active {
               opacity: 0.7;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               opacity: 40%;
               cursor: not-allowed;
            }
         `;
      case "grey":
         return css`
            color: ${theme.colors.white};
            background-color: #42425f;
            border: 1px solid ${theme.colors.grey};

            &:hover,
            &:active {
               opacity: 0.8;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               opacity: 40%;
               cursor: not-allowed;
            }
         `;
      case "link":
         return css`
            color: ${theme.colors.white};
            background: none;
            font-weight: 500;
            padding-left: 0;

            &:hover,
            &:active {
               opacity: 0.8;
            }

            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               color: ${theme.colors.grey01};
               cursor: not-allowed;
            }
         `;
      default:
      case "primary":
         return css`
            color:  ${({ theme }) => theme.colors?.white};
            background-color: ${({ theme }) => theme.colors?.green};

            &:hover,
            &:active {
               color: ${({ theme }) => theme.colors?.white};
               background-color: ${({ theme }) => theme.colors?.green};
               opacity: 0.8;
            }

            &:disabled,
            &:disabled:active,
            &:disabled,
            &:disabled:active,
            &:disabled:hover {
               opacity: 40%;
               cursor: not-allowed;
            }
         `;
   }
}

export const ButtonStyledComponent = styled.button`
   font-family: 'Work Sans', sans-serif;
   border: 0;
   padding: 0;
   cursor: pointer;
   box-sizing: border-box;
   display: inline-block;
   max-width: 100%;
   text-align: center;
   overflow: hidden;
   white-space: nowrap;
   text-overflow: ellipsis;
   font-size: ${({ size }) => {
      switch (size) {
         case "small":
            return "1.4rem;";
         case "medium":
            return "1.8rem;";
         case "large":
            return "2rem;";
         default:
            return "1.6rem;";
      }
   }};
   letter-spacing: 0;
   line-height: 1.6rem;
   /* font-weight: bold; */
   border-radius: .8rem;
   /* text-transform: uppercase; */
   transition: all 300ms ease-in-out;
   background-color: ${({ theme }) => theme.colors?.green};
   color: ${({ theme }) => theme.colors?.white};
   display: flex;
   justify-content: center;
   align-items: center;
   padding: ${({ size }) => {
      switch (size) {
         case "small":
            return "1.1rem 1.6rem;";
         case "medium":
            return "1.1rem 3rem;";
         case "large":
            return "2rem 10rem;";
         default:
            return "1.6rem 8rem;";
      }
   }};

   ${({ fullWidth }) =>
      fullWidth &&
      css`
         width: 100%;
      `};
      ${({ responsive }) =>
      responsive &&
      css`
        @media only screen and (max-width: 468px) {
            width: 100%;
            margin-bottom: 20px;
            margin-left: 0px !important;
        }
      `};
    

   ${variantButtonStyles}
`;
